import Text from "../components/Text";
import { IoSearch } from "react-icons/io5";
import logo from "../assets/images/logo.png";
import IconText from "../components/IconText";
import MobileMenu from "./MobileMenu";
import React, { useRef, useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Modal from "../components/Modal";
import LoginForm from "../components/LoginForm";
import Button from "../components/Button";
import RegisterForm from "../components/RegisterForm";

const Header = () => {
  const [menubarOpen, setMenuBarOpen] = useState(false);
  const mobileRef = useRef(null);

  useEffect(() => {
    const html = document.getElementsByTagName("html")[0];
    if (menubarOpen) {
      html.classList.add("overflow-hidden");
    } else {
      html.classList.remove("overflow-hidden");
    }
  });

  const handleClick = () => {
    setMenuBarOpen(!menubarOpen);
  };
  return (
    <>
      <header className="py-[15px] p-1 bg-white">
        <div className="lg:w-[95%] m-auto max-w-[1400px]">
          <div className="flex flex-row items-center font-normal text-[15px] xs:flex-wrap xl:flex-nowrap p-1">
            <div
              className="open-close cursor-pointer xs:py-2 xl:py-0 xs:px-4 xs:block lg:hidden z-30 flex"
              onClick={handleClick}
            >
              <div className="menu-bars w-9 h-9 flex flex-col justify-center p-1">
                <span
                  className={`border rounded-full border-black w-5/6 mb-1 relative transition-all duration-300 ${
                    menubarOpen ? "translate-y-1/2 rotate-45 mb-0" : "rotate-0"
                  }`}
                ></span>
                <span
                  className={`border rounded-full border-black w-1/2 mb-1 ${
                    menubarOpen ? "hidden" : "block"
                  }`}
                ></span>
                <span
                  className={`border rounded-full border-black w-5/6 mb-1 relative transition-all duration-300 ${
                    menubarOpen
                      ? "-translate-y-1/2 -rotate-45 mb-0"
                      : "rotate-0"
                  }`}
                ></span>
              </div>
            </div>
            <div className="logo xs:py-2 xl:py-0 xs:px-4 z-30">
              <Link to="/everyone">
                <img
                  src={logo}
                  alt=""
                  className="xs:max-w-[120px] lg:max-w-[140px]"
                />
              </Link>
            </div>
            <div className="search flex flex-row logo xs:py-2 xl:py-0 xs:px-4 items-center justify-center xs:w-full lg:flex-auto xs:order-last xl:order-none xs:text-[13px] md:text-inherit">
              <div className="form relative  w-full">
                <form action="#">
                  <div className="input-text py-2 bg-[#f3f3f3] rounded-full">
                    <input
                      type="text"
                      className="outline-none font-light py-2 w-full px-3 bg-transparent"
                      placeholder="Dietitian in Istanbul, Protein Bar.."
                    />
                  </div>
                  <div className="input-submit absolute top-1/2 -translate-y-1/2 right-2">
                    <IconText
                      iconInfo={{
                        Icon: IoSearch,
                        classes:
                          "p-2 text-4xl rounded-full bg-[#e66553] text-white",
                      }}
                    />
                  </div>
                </form>
              </div>
            </div>
            <nav className="nav flex flex-row xs:py-2 xl:py-0 items-center flex-1 xs:px-2 sm:px-8 lg:px-4 xs:justify-end xl:justify-start">
              <Link
                to={"influencers"}
                className="xs:hidden lg:inline-block px-2 py-3"
              >
                <Text text={"Find a Dietitian"} classes="truncate" />
              </Link>
              <Link to="shop" className="xs:hidden lg:inline-block px-2 py-3">
                <Text text={"Shop"} />
              </Link>
              <Link
                to="gepzo-box"
                className="xs:hidden lg:inline-block px-2 py-3"
              >
                <Text text={"Gepzo Box"} classes="truncate" />
              </Link>
              <div className="">
                <Link
                  to={"/log-in"}
                  className="inline-block px-2 py-3 cursor-pointer"
                >
                  Login
                </Link>
              </div>
              <div className="xs:hidden lg:inline-block">
                <Link
                  to={"/register/step-1"}
                  className="inline-block p-2 ml-2 text-black bg-transparent border-2 border-black rounded transition-all duration-200 hover:text-white hover:bg-black"
                >
                  Register
                </Link>
              </div>
            </nav>
          </div>
        </div>
        <MobileMenu
          ref={mobileRef}
          menubarOpen={menubarOpen}
          handleClick={handleClick}
        />
      </header>
    </>
  );
};

const RegisterNavItem = () => {
  return (
    <Button
      font={"text-black"}
      backgroundColor="bg-transparent"
      padding={"p-2 ml-2"}
      border="border-2 border-black"
      isHovered
      hover={"hover:text-white hover:bg-black"}
    >
      Register
    </Button>
  );
};

export default Header;
